import { resume } from '../../data/resume';
import LabelField from '../layout/LabelField';
import SectionHeading from '../layout/SectionHeading';

/**
 * About section: a labelled introduction reminiscent of the top half of a
 * print form. Mono-cap field labels, script/serif written values, three
 * checkbox traits for character, and the paragraph in Fraunces below.
 */

const About = () => {
  const { name, status, title, about } = resume;

  return (
    <section className="border-b-[3px] border-ink bg-paper-base px-8 py-10">
      <SectionHeading kana="自己紹介" accent="text-accent-oxblood">
        About
      </SectionHeading>

      <div className="grid gap-8 md:grid-cols-[1.05fr_1fr]">
        <div className="space-y-3">
          <LabelField
            label="Name"
            value={name
              .split(' ')
              .map((w) => w[0] + w.slice(1).toLowerCase())
              .join(' ')}
            valueFont="mono"
          />
          <LabelField
          label="Status"
          value={status}
          valueFont="mono"
          />
          <LabelField
            label="Role"
            value={title.toLowerCase().replace(/^\w/, (c) => c.toUpperCase())}
            valueFont="mono"
          />
          <LabelField label="Based" value="Minsk, Belarus" valueFont="mono" />
        </div>

        <div className="relative">
          <p className="font-serif text-lg leading-relaxed text-ink">
            <span className="float-left mr-2 mt-1 font-display text-6xl font-bold leading-[0.8] text-accent-oxblood">
              {about.charAt(0)}
            </span>
            {about.slice(1)}
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
